import { useQuery } from "@tanstack/react-query";
import { useParams } from "react-router-dom";
import { useApi } from "~hooks/apiHooks/useApi";
import { transformSeasonPools } from "~pages/SeasonPools/utilities/transformSeasonPools.ts";
import type { PoolResponse } from "~types/pool.ts";
import { removeEmptyFields } from "~utils/removeEmptyFields.ts";
import { transformListResponse } from "~utils/transformListResponse.ts";

type Props = {
  customParams: Record<string, string>;
  enabled?: boolean;
};

export const useFetchSeasonPools = ({ customParams, enabled = true }: Props) => {
  const request = useApi();
  const { organizationId, sport, seasonId = "" } = useParams();

  const params = new URLSearchParams(
    removeEmptyFields({
      ...customParams,
      include: "seasonStages",
    }) as Record<string, string>,
  );

  return useQuery({
    queryKey: ["seasonPools", sport, organizationId, seasonId, customParams],
    enabled,
    queryFn: () =>
      request<PoolResponse>(`${sport}/o/${organizationId}/seasons/${seasonId}/pools?${params.toString()}`).then((response) => {
        const resources = response?.includes?.resources;
        const data = transformSeasonPools(response?.data || [], resources, seasonId);

        return transformListResponse({ ...response, data });
      }),
  });
};
